export const heroData = {
  title: "Chatbots for sales: focus reps on hot leads only",
  subtitle:
    "Use chatbots to qualify visitors, book meetings, and shorten the sales cycle. Reps spend their time only on prospects ready to talk.",
  image: "/custom-chatbot-roles/chatbot-for-sales/cover.jpg",
  imageAlt: "Chatbot for sales team",
};

export const featuresHeading = "Drive sales conversions in real time with chatbots";

export const features = [
  {
    title: "Qualify leads, focus reps on hot ones",
    text: "The sales chatbot collects, segments, and qualifies leads. Sales managers stop wasting hours on tire-kickers.",
    image: "/custom-chatbot-roles/chatbot-for-sales/img0.png",
  },
  {
    title: "Collect leads at night and on weekends",
    text: "Don't lose hot leads on days off. Customers see +20% revenue without extra investment by letting chatbots queue inquiries.",
    image: "/custom-chatbot-roles/chatbot-for-sales/img1.png",
  },
  {
    title: "Hand FAQs to chatbots",
    text: "Resolve common questions in seconds, route harder ones to the right team automatically.",
    image: "/custom-chatbot-roles/chatbot-for-sales/img2.png",
  },
  {
    title: "Push trial users to convert",
    text: "Show sales chatbots to ready-to-buy segments. Remind users that the trial expires and help them choose the right plan.",
    image: "/custom-chatbot-roles/chatbot-for-sales/img3.png",
  },
  {
    title: "Enrich CRM with answers automatically",
    text: "Map chatbot answers into CRM fields. Sales reps walk into every call already knowing the context.",
    image: "/custom-chatbot-roles/chatbot-for-sales/img4.png",
  },
  {
    title: "Book meetings without the back-and-forth",
    text: "Visitors pick their slot from the chatbot. The agent gets event details and context with zero scheduling chat.",
    image: "/custom-chatbot-roles/chatbot-for-sales/img5.png",
  },
  {
    title: "Capture hot leads from social media",
    text: "Run sales chatbots on social channels too. Conversations carry over from a Facebook ad to your CRM without hiring extra agents.",
    image: "/custom-chatbot-roles/chatbot-for-sales/img6.png",
  },
  {
    title: "Hybrid live chat + chatbot handoff",
    text: "Chatbots handle volume, agents handle nuance. The seamless handoff cuts response time and lifts conversion.",
    image: "/custom-chatbot-roles/chatbot-for-sales/img7.png",
  },
  {
    title: "Scale service without scaling the team",
    text: "Chatbots run unlimited parallel conversations. Productivity goes up without adding headcount.",
    image: "/custom-chatbot-roles/chatbot-for-sales/img8.png",
  },
];

export const comingSoon = {
  title: "Coming soon: chatbot in messengers",
  text: "Soon you'll be able to run the chatbot not only on the website, but also in WhatsApp, Telegram, and Instagram. Be among the first to test it.",
  image: "/custom-chatbot-roles/chatbot-for-sales/img9.png",
};

export const finalCta = {
  title: "Build a chatbot that lifts your sales team's efficiency",
  videoSrc: "/custom-chatbot-roles/chatbot-for-sales/766bc1404a56.mp4",
};
